import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    statusLabel: {
      alignItems: 'flex-start',
      color: theme.palette.text.secondary,
    },
    statusLabelTitle: {
      display: 'block',
      lineHeight: '2.625rem',
      fontWeight: 700,
    },
    statusLabelWarning: {
      display: 'block',
      color: theme.palette.general.red,
      fontSize: '0.875rem',
    },
    statusLabelDescription: {
      display: 'block',
      fontSize: '0.875rem',
    },
    confirmContent: {
      fontSize: '0.875rem',
      color: theme.palette.text.secondary,
    },
    confirmWarning: {
      display: 'block',
      color: theme.palette.general.red,
    },
    confirmContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '2.5rem',
    },
    confirmTop: {
      marginTop: '4rem',
    },
    confirmHeader: {
      paddingRight: '2rem',
    },
    confirmTitle: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem',
      marginBottom: '0.75rem',
      textAlign: 'center',
    },
    confirmDescription: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      marginBottom: '1.5rem',
      color: theme.palette.text.secondary,
      display: 'block',
      textAlign: 'center',
    },
    confirmButton: {
      textTransform: 'capitalize',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    inviteContainer: {
      overflow: 'visible',
    },
    modalSubtitle: {
      width: '520px',
      margin: 'auto',
      textAlign: 'center',
      color: theme.palette.general.grey60,
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
    },
    modalTitle: {
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '28px',
      marginBottom: '10px',
    },
    mandatory: {
      color: theme.palette.common.pendingOrange,
    },
  };
});

export { useStyles };
